import { I18N_NAMESPACE } from "@/config/i18n";
import { depositEligibleBonusPlansDataSelector } from "@/fe-core/_redux/selectors/userSelectors/bonusSelectors";
import { processDepositPendingSelector } from "@/fe-core/_redux/selectors/userSelectors/cashierSelectors/processDepositSelectors";
import { useTranslations } from "next-intl";
import Image from "next/image";
import Link from "next/link";
import { useSelector } from "react-redux";
import { Logo } from "../Logo";
import SVGIcon from "../SVGIcon";

const DepositBonuses = ({
  selectedBonusPlanId,
  setSelectedBonusPlanId,
}: {
  selectedBonusPlanId: number | null;
  setSelectedBonusPlanId: Function;
}) => {
  const depositBonusPlans = useSelector(depositEligibleBonusPlansDataSelector);
  const processDepositPending = useSelector(processDepositPendingSelector);

  const t = useTranslations(I18N_NAMESPACE.DEPOSIT);

  return depositBonusPlans && depositBonusPlans?.length > 0 ? (
    <>
      <div className="flex justify-center items-center mt-5 relative h-5">
        <hr className="border-white/10 w-full" />
        <p className="text-white/80 px-2 bg-tertiary-700 uppercase font-semibold text-xs text-center whitespace-nowrap absolute top-0 left-1/2 transform -translate-x-1/2">
          {t("available-bonueses")}
        </p>
      </div>
      <div className="px-0.5 space-y-3">
        <div className="flex items-center gap-3 p-3 py-4 cursor-pointer relative ">
          <input
            type="radio"
            name="bonus"
            id="no-bonus"
            checked={selectedBonusPlanId === null}
            onChange={() => setSelectedBonusPlanId(null)}
            className="form-radio relative z-[1] peer"
            disabled={processDepositPending}
          />
          <label
            htmlFor="no-bonus"
            className="text-xs font-semibold absolute inset-0 pl-10 h-full flex items-center rounded-md bg-tertiary-600 border-primary-800/50 border peer-checked:ring-secondary-500 peer-checked:ring-1 cursor-pointer"
          >
            {t("no-bonus-header")}
          </label>
        </div>
        {depositBonusPlans
          ?.slice()
          ?.reverse()
          ?.map((bonus) => (
            <div
              className="flex items-center gap-3 cursor-pointer relative "
              key={bonus?.bonusPlanId}
            >
              <div className="absolute w-10 rounded-l h-full top-0 left-0 bg-gradient-to-r from-black/30 to-transparent bg-blend-multiply" />
              <input
                type="radio"
                name="bonus"
                value={bonus?.bonusPlanId}
                id={`bonus-${bonus?.bonusPlanId}`}
                checked={bonus?.bonusPlanId === selectedBonusPlanId}
                onChange={() => setSelectedBonusPlanId(bonus?.bonusPlanId)}
                className="form-radio left-3 z-[1] !absolute"
                disabled={processDepositPending}
              />
              <label
                htmlFor={`bonus-${bonus?.bonusPlanId}`}
                className={`text-xs flex gap-3 font-semibold cursor-pointer inset-0 pl-10 h-full rounded-md bg-tertiary-600 border-primary-800/50 border p-3 py-4 w-full ${
                  selectedBonusPlanId === bonus?.bonusPlanId
                    ? "ring-secondary-500 ring-1"
                    : ""
                }`}
              >
                <div className="flex-1 space-y-1">
                  <span className="block text-xs uppercase font-semibold">
                    {bonus?.bonusPlanName}
                  </span>
                  <span className="block text-xs font-normal break-words">
                    {bonus?.description}
                  </span>
                </div>

                <div className="w-28 min-w-28 relative aspect-[112/141] bg-primary-800 rounded-md overflow-hidden bg-cover bg-center">
                  {/* <Link
                    className="absolute top-2 right-2 z-[1] hover:scale-125 transform"
                    href={`/modals/bonus-policy`}
                  >
                    <SVGIcon
                      icon="exclamation"
                      className="w-4 h-4 text-[#DCF500]"
                    />
                  </Link> */}
                  {bonus?.imageUrl ? (
                    <Image
                      src={bonus?.imageUrl}
                      alt={bonus?.bonusPlanName}
                      fill
                      objectFit="cover"
                    />
                  ) : (
                    <div className=" flex items-center justify-center  h-full">
                      <Logo logoClassName="!max-h-3" />
                    </div>
                  )}
                </div>
              </label>
            </div>
          ))}
      </div>
    </>
  ) : (
    <></>
  );
};

export default DepositBonuses;
